__turbopack_context__.v({
  "dark": "o-footnotes-module-scss-module__ojWxtq__dark",
  "footnotes": "o-footnotes-module-scss-module__ojWxtq__footnotes",
  "light": "o-footnotes-module-scss-module__ojWxtq__light",
  "placeholder": "o-footnotes-module-scss-module__ojWxtq__placeholder",
});
